export enum IndustryType {
  Water = "Water Utilities",
  Spring = "Spring Water",
  Agriculture = "Agriculture",
  Fishing = "Fishing",
  Mining = "Mining",
  Refinery = "Refinery",
  Restaurant = "Restaurant",
  Tobacco = "Tobacco",
  Chemical = "Chemical",
  Pharmaceutical = "Pharmaceutical",
  Computers = "Computer Hardware",
  Robotics = "Robotics",
  Software = "Software",
  Healthcare = "Healthcare",
  RealEstate = "Real Estate",
}

export enum CorpEmployeeJob {
  Operations = "Operations",
  Engineer = "Engineer",
  Business = "Business",
  Management = "Management",
  RandD = "Research & Development",
  Intern = "Intern",
  Unassigned = "Unassigned",
}

export enum CorpUnlockName {
  Export = "Export",
  SmartSupply = "Smart Supply",
  MarketResearchDemand = "Market Research - Demand",
  MarketDataCompetition = "Market Data - Competition",
  VeChain = "VeChain",
  ShadyAccounting = "Shady Accounting",
  GovernmentPartnership = "Government Partnership",
  WarehouseAPI = "Warehouse API",
  OfficeAPI = "Office API",
}

export enum CorpUpgradeName {
  SmartFactories = "Smart Factories",
  SmartStorage = "Smart Storage",
  DreamSense = "DreamSense",
  WilsonAnalytics = "Wilson Analytics",
  NuoptimalNootropicInjectorImplants = "Nuoptimal Nootropic Injector Implants",
  SpeechProcessorImplants = "Speech Processor Implants",
  NeuralAccelerators = "Neural Accelerators",
  FocusWires = "FocusWires",
  ABCSalesBots = "ABC SalesBots",
  ProjectInsight = "Project Insight",
}
